module.exports = __webpack_public_path__ + "static/media/icon-close.b223b8bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-close.svg
// module id = 82
// module chunks = 0